export const STEP_FOUR = {
  flowName: 'Suscribir APV',
  title: 'Paso 4: Confirma tu suscripción',
  subtitle: 'Revisa los datos antes de terminar',
  back: 'Volver al paso anterior',
  savingTitle: 'Ahorro mensual',
  regimeTitle: 'Régimen y fondo',
  employerTitle: 'Datos empleador',
  userTitle: 'Tus datos',
  executiveTitle: '¿Te guió un ejecutivo?',
  executiveLabel: 'Ingresa su RUT (Opcional)',
  executivePlaceholder: '12.345.678-9',
  executiveError:
    'No encontramos un ejecutivo con ese RUT. Por favor, valida que sea correcto.',
  editButton: 'Editar',
  acceptText:
    'Acepto que la información ingresada es correcta. Autorizo a mi empleador a descontar de mi remuneración mensual para aportar a mi APV.',
  submitButton: 'Suscribir APV',
};

export const CONFIRM_LABELS = {
  regime: 'Régimen:',
  fund: 'Fondo:',
  firstDiscount: 'Primer descuento:',
  savingStart: 'Inicio ahorro APV:',
  email: 'Correo:',
  name: 'Nombre:',
  rut: 'RUT:',
};

export const EMPLOYER_SUMMARY_LABELS = {
  businessName: 'Razón social:',
  activity: 'Giro:',
  address: 'Dirección:',
  region: 'Región:',
  commune: 'Comuna:',
  city: 'Ciudad:',
  phone: 'Teléfono:',
  rut: 'RUT:',
};
